import { DeepPartial, OpenConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_OPEN_CONFIG: DeepPartial<OpenConfig> = {
  triggersSelector: '.search-wrapper'
};
